import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL || '';

interface HeartbeatPayload {
  connectionId: string;
  webinarId: string;
  userId: string;
}

const sendHeartbeat = async (payload: HeartbeatPayload): Promise<{ status: number; data: any }> => {
  try {
    const response = await axios.post(`${HOSTAPI}/connection/heartbeat`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response?.status || 500,
      data: error.response?.data || error.message || 'Unknown error',
    };
  }
};

export default sendHeartbeat;
